
var target;
var control;
import Swiper from 'Swiper';
import 'swiper/css/swiper.min.css';
if (viewportIsMobile($("body").outerWidth())) {

  var swiper = new Swiper('.swiper-container', {
    grabCursor: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    // speed: 700,
    // preloadImages: false,
    // centeredSlides: false,
    // loop: false,
    // Enable lazy loading
    lazy: true,
    // slidesPerView: 'auto',
    // autoplayDisableOnInteraction: false,
    breakpoints: {
      320: {
        slidesPerView: 4,
        spaceBetween: 50
      },
      480: {
        slidesPerView: 4,
        spaceBetween: 50,
      },
      768: {
        slidesPerView: 5,
        spaceBetween: 50
      },
    }
  });
}

function viewportIsMobile(width) {
  return (width < 1025);
}